
<script>
//SampleSource https://codesandbox.io/s/suoyc?file=/src/Navigation.vue
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import Navigation from '@/components/EndUser/PartsCropperNavigation'

export default {
    components: {
        Cropper,
        Navigation,
    },
    data() {
        return {
        zoom: 0,
        img: require("/img/smp/001.jpg"),
        };
    },
    methods: {
        defaultSize({ imageSize }) {
        return {
            width: Math.min(imageSize.height, imageSize.width),
            height: Math.min(imageSize.height, imageSize.width),
        };
        },
        stencilSize({ boundaries }) {
        return {
            width: Math.min(boundaries.height, boundaries.width) - 48,
            height: Math.min(boundaries.height, boundaries.width) - 48,
        };
        },
        onChange(result) {
        const cropper = this.$refs.cropper;
        if (cropper) {
            const { coordinates, imageSize } = cropper;
            if (
            imageSize.width / imageSize.height >
            coordinates.width / coordinates.height
            ) {
            // Determine the position of slider bullet
            // It's 0 if the stencil has the maximum size and it's 1 if the has the minimum size
            this.zoom =
                (cropper.imageSize.height - cropper.coordinates.height) /
                (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
            } else {
            this.zoom =
                (cropper.imageSize.width - cropper.coordinates.width) /
                (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
            }
        }
        },
        onZoom(value) {
        const cropper = this.$refs.cropper;
        if (cropper) {
            if (cropper.imageSize.height < cropper.imageSize.width) {
            const minHeight = cropper.sizeRestrictions.minHeight;
            const imageHeight = cropper.imageSize.height;
            // Determine the current absolute zoom and the new absolute zoom
            // to calculate the sought relative zoom value
            cropper.zoom(
                (imageHeight - this.zoom * (imageHeight - minHeight)) /
                (imageHeight - value * (imageHeight - minHeight))
            );
            } else {
            const minWidth = cropper.sizeRestrictions.minWidth;
            const imageWidth = cropper.imageSize.width;
            cropper.zoom(
                (imageWidth - this.zoom * (imageWidth - minWidth)) /
                (imageWidth - value * (imageWidth - minWidth))
            );
            }
        }
        },
    },
    };
</script>

<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>STEP<span>08</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>ショップの紹介画像の登録</span></h3>
                <p>ログインIDとして利用するメールアドレスを入力してください。入力したメールアドレスに確認メールが届きますので、記載されているURLをクリックして会員登録を進めてください。AUMAではなりすましなどを防止するために会社や団体でご利用されているドメインのメールアドレス（メーリングリスト）を登録することを推奨しております。</p>
            </div>

            <!--item-->
            <div class="item-wrap">
                <div class="item ">

                    <cropper
                        ref="cropper"
                        class="twitter-cropper"
                        background-class="twitter-cropper__background"
                        foreground-class="twitter-cropper__foreground"
                        image-restriction="stencil"
                        :stencil-size="stencilSize"
                        :stencil-props="{
                            lines: {},
                            handlers: {},
                            movable: false,
                            scalable: false,
                            aspectRatio: 1,
                            previewClass: 'twitter-cropper__stencil',
                        }"
                        :transitions="false"
                        :canvas="false"
                        :debounce="false"
                        :default-size="defaultSize"
                        :min-width="150"
                        :min-height="150"
                        :src="img"
                        @change="onChange"
                    />
                    <navigation :zoom="zoom" @change="onZoom" />

                </div>
                <div class="item ">

                    <cropper
                        ref="cropper"
                        class="twitter-cropper"
                        background-class="twitter-cropper__background"
                        foreground-class="twitter-cropper__foreground"
                        image-restriction="stencil"
                        :stencil-size="stencilSize"
                        :stencil-props="{
                            lines: {},
                            handlers: {},
                            movable: false,
                            scalable: false,
                            aspectRatio: 1,
                            previewClass: 'twitter-cropper__stencil',
                        }"
                        :transitions="false"
                        :canvas="false"
                        :debounce="false"
                        :default-size="defaultSize"
                        :min-width="150"
                        :min-height="150"
                        :src="img"
                        @change="onChange"
                    />
                    <navigation :zoom="zoom" @change="onZoom" />

                </div>
            </div>
        </div>

        <div class="control-wrap">
            <button type="button" class="_left js-swiper-prev"><span>Back</span></button>
            <button type="button" class="_right js-swiper-next"><span>Next</span></button>
        </div>

    </div>
</div>
</template>

